export class StartupModel {
    Applab_id: string;
    status: string;
    Applab_FirstName:string
    Applab_LastName: string;
    Applab_Email: string;
    Applab_Contact: string;
    Applab_UniversityName: string;
    Applab_InstituteName: string;
    Applab_ProgramName: string;
    Applab_Student_Alumni: string;
    Applab_StartupName: string;
    Applab_ProblemStatement: string;
    Applab_IdeaPitch: string;
    Applab_BPlan: string;
    Applab_DeviceType: string;
}

export class ImageUploadUrl {
    imgUrl: string;
}
